module.exports = __webpack_public_path__ + "img/AppStoreQR.76aedd14.svg";